import { PageFilter } from 'hooks/usePageFilters/usePageFilters';
import { AppTableProps } from 'components/organisms';
import {
    ApplicationStatus,
    EnrollmentItem,
    GetEnrollmentFilterKey,
} from 'types/enrollment/enrollment';
import { childrenTexts, commonTexts, enrollmentTexts } from 'consts/text';
import { enrollmentFields } from 'consts/enrollment/enrollmentFields';
import {
    AddressDisplay,
    ChildFirstAndLastNameDisplay,
    ChildSexDisplay,
    SchoolYearsDisplay,
    PhoneNumberDisplay,
} from 'components/molecules';
import { ApplicationStatusTag } from 'components/molecules/ApplicationStatusTag/ApplicationStatusTag';

export const filters: PageFilter<GetEnrollmentFilterKey>[] = [
    { name: 'status', type: 'SINGLE_VALUE' },
    { name: 'fromYear', type: 'SINGLE_VALUE' },
    { name: 'toYear', type: 'SINGLE_VALUE' },
];

export const columns: AppTableProps<EnrollmentItem>['columns'] = [
    {
        title: commonTexts.dataLabels.lastnameAndFirstname,
        dataIndex: enrollmentFields.firstName,
        key: enrollmentFields.firstName,
        render: (_, record) => (
            <ChildFirstAndLastNameDisplay
                firstName={record.child.firstName}
                lastName={record.child.lastName}
            />
        ),
        isVisibleAsExtendableInMobile: false,
    },
    {
        title: childrenTexts.childrenListColumns.sex,
        dataIndex: enrollmentFields.sex,
        key: enrollmentFields.sex,
        render: (_, record) => <ChildSexDisplay sex={record.child.sex} />,
        isVisibleAsExtendableInMobile: true,
    },
    {
        title: commonTexts.dataLabels.schoolYear,
        dataIndex: enrollmentFields.schoolYear,
        key: enrollmentFields.schoolYear,
        render: (_, record) => <SchoolYearsDisplay schoolYears={[record.schoolYear]} />,
        isVisibleAsExtendableInMobile: true,
    },
    {
        title: enrollmentTexts.enrollmentTable.parentName,
        dataIndex: enrollmentFields.parentName,
        key: enrollmentFields.parentName,
        render: (_, record) => record.parent.firstName,
        isVisibleAsExtendableInMobile: true,
    },
    {
        title: commonTexts.dataLabels.phoneNumber,
        dataIndex: enrollmentFields.phoneNumber,
        key: enrollmentFields.phoneNumber,
        render: (_, record) => <PhoneNumberDisplay phoneNumber={record.parent.phoneNumber} />,
        isVisibleAsExtendableInMobile: true,
    },
    {
        title: commonTexts.dataLabels.address,
        dataIndex: enrollmentFields.address,
        key: enrollmentFields.address,
        render: (_, record) => <AddressDisplay address={record.child.address} />,
        isVisibleAsExtendableInMobile: true,
    },
    {
        title: commonTexts.dataLabels.status,
        dataIndex: enrollmentFields.status,
        key: enrollmentFields.status,
        render: (_, record) => <ApplicationStatusTag status={record.status as ApplicationStatus} />,
        isVisibleAsExtendableInMobile: true,
    },
];
